import { render, staticRenderFns } from "./Actuaciones.vue?vue&type=template&id=75a0607e&scoped=true"
import script from "./Actuaciones.vue?vue&type=script&lang=js"
export * from "./Actuaciones.vue?vue&type=script&lang=js"
import style0 from "./Actuaciones.vue?vue&type=style&index=0&id=75a0607e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a0607e",
  null
  
)

export default component.exports